import * as React from 'react';

import { createStackNavigator } from '@react-navigation/stack';

import AppHeader from '../components/AppHeader';
import FormTemplateScreen from '../screens/form-template/FormTemplateScreen';
import MyStudiesScreen from '../screens/my-studies/MyStudiesScreen';
import NotebookDetailScreen from '../screens/notebook/NotebookDetailScreen';
import NotebookListScreen from '../screens/notebook/NotebookListScreen';
import CreateStudyScreen from '../screens/study-generator/CreateStudyScreen';
import StudyComingSoonScreen from '../screens/study-generator/StudyComingSoonScreen';
import StudyGeneratorIntroScreen from '../screens/study-generator/StudyGeneratorIntroScreen';
import StudyEditScreen from '../screens/study/StudyEditScreen';
import StudyEventFormScreen from '../screens/study/StudyEventFormScreen';
import ScreenFailedMessageScreen from '../screens/study/ScreenFailedMessageScreen';
import StudyView from '../screens/study/StudyScreen';
import { DrawerParamList } from './DrawerNavigator';
import { getScreenOptions } from './getScreenOptions';
import { QualificationParamList } from '../web-navigation/QualificationNavigator';
import QualificationFormScreen from '../screens/qualification/QualificationFormScreen';
import QualificationCompleteScreen from '../screens/qualification/QualificationCompleteScreen';
import { StudyType } from '../models/Study';

export type StudiesParamList = {
  MyStudies: undefined;
  StudyInfo: {
    studyId: number;
    studyParticipantId: number;
  };
  StudyEdit: {
    studyName?: string;
    startDate: string;
    studyLength: number;
    studyId: number;
    studyType: StudyType;
    allowSelfWithdraw: boolean;
    studyParticipantId: number;
    notificationTime?: string;
    type: 'planning' | 'progress';
  };
  StudyGenerator: undefined;
  CreateStudy:
    | { path?: string; sectionIndex?: number; backAnimation?: boolean }
    | undefined;
  StudyComingSoon: { category: string };
  // Allow nesting FormTemplate under Study Screen
  FormTemplate: DrawerParamList['FormTemplate'];
  FormTemplateModal: DrawerParamList['FormTemplate'];
  StudyEventForm: {
    entityDataId?: number;
    path?: string;
    sectionIndex?: number;
    backAnimation?: boolean;
    studyParticipantId: number;
    participantEventId: number;
    participantEventLogId?: number;
    occurrenceCount: number;
  };
  StudyNotebook: {
    studyParticipantId: number;
  };
  QualificationForm: QualificationParamList['QualificationForm'];
  QualificationComplete: QualificationParamList['QualificationComplete'];
  StudyNotebookDetail: { date: string; studyParticipantId: number };
  ScreenFailedMessage: {
    message: string;
  };
};

const StudiesStack = createStackNavigator<StudiesParamList>();
export default function StudiesNavigator() {
  return (
    <StudiesStack.Navigator
      initialRouteName='MyStudies'
      screenOptions={({ route }) => ({
        ...getScreenOptions(route),
        header: () => <AppHeader />,
        headerShown: true,
        headerMode: 'float',
        gestureEnabled: false
      })}
    >
      <StudiesStack.Screen name='MyStudies' component={MyStudiesScreen} />
      <StudiesStack.Screen name='StudyInfo' component={StudyView} />
      <StudiesStack.Screen name='StudyEdit' component={StudyEditScreen} />
      <StudiesStack.Screen
        name='StudyGenerator'
        component={StudyGeneratorIntroScreen}
      />
      <StudiesStack.Screen name='CreateStudy' component={CreateStudyScreen} />
      <StudiesStack.Screen
        name='StudyComingSoon'
        component={StudyComingSoonScreen}
      />
      <StudiesStack.Screen name='FormTemplate' component={FormTemplateScreen} />
      <StudiesStack.Group screenOptions={{ presentation: 'modal' }}>
        <StudiesStack.Screen
          name='FormTemplateModal'
          component={FormTemplateScreen}
        />
      </StudiesStack.Group>
      <StudiesStack.Screen
        name='StudyEventForm'
        component={StudyEventFormScreen}
      />
      <StudiesStack.Screen
        name='StudyNotebook'
        component={NotebookListScreen}
      />
      <StudiesStack.Screen
        name='StudyNotebookDetail'
        component={NotebookDetailScreen}
      />
      <StudiesStack.Screen
        name='QualificationForm'
        component={QualificationFormScreen}
      />
      <StudiesStack.Screen
        name='QualificationComplete'
        component={QualificationCompleteScreen}
      />
      <StudiesStack.Screen
        name='ScreenFailedMessage'
        component={ScreenFailedMessageScreen}
      />
    </StudiesStack.Navigator>
  );
}
